import ReactDOM from 'react-dom'

import Application from './app-support/Application'

import 'assets/styles/main.less'

// Before React renders the application we need to include the MUI license.
// This removes the watermarks from the MUI Pro components and keeps
// us compliant with the license.
import './utils-support/mui-license'

ReactDOM.render(<Application />, document.getElementById('root'))
